export default __webpack_public_path__ + "static/media/times-circle-regular.f5231b70.svg";